import React from 'react'
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../../../hooks/routes/url-constant';

const SearchData = () => {
    const { t } = useTranslation();
    return [
        { id: 1, name: t("Home"), url: ROUTES.HOME, },
        { id: 2, name: t("Message"), url: `${process.env.PUBLIC_URL}/message-page/chairperson` },
        { id: 3, name: t("ChairpersonsDesk"), url: `${process.env.PUBLIC_URL}/message-page/chairperson`, },
        { id: 4, name: t("CEOsDesk"), url: `${process.env.PUBLIC_URL}/message-page/ceodesk`, },
        { id: 5, name: t("Governance"), url: ROUTES.GOVERNANCE, },
        { id: 6, name: t("GoverningCouncil"), url: ROUTES.GOVERNANCE, },
        { id: 7, name: t("ExecutiveCouncil"), url: ROUTES.EXECUTIVE, },
        { id: 8, name: t("OrganizationChart"), url: ROUTES.ORGANIZATION, },
        { id: 9, name: t("ManagementTeam"), url: ROUTES.MANAGEMENT, },
        // { id: 10, name: t("PMBJP"), url: ROUTES.ABOUTUS, },
        // { id: 11, name: t("PMBI"), url: ROUTES.ABOUTUS, },
        { id: 12, name: t("PMBJPScheme"), url: ROUTES.PMBJBSCHEME, },
        { id: 13, name: t("LocatePMBJPKendra"), url: ROUTES.LOCATEKENDRA, },
        { id: 14, name: t("LocateDistributor"), url: ROUTES.LOCATEDISTRIBUTOR, },
        { id: 15, name: t("PharmacistDetails"), url: ROUTES.PHARMACISTDETAILS, },
        { id: 16, name: t("ABPMJAYHospital"), url: ROUTES.PMHOSPITAL, },
        { id: 17, name: t("AnnualReport"), url: ROUTES.ANNUALREPORT, },
        { id: 18, name: t("FinancialReport"), url: ROUTES.FINANCEREPORT, },
        { id: 19, name: t("FAQs"), url: ROUTES.FAQ, },
        { id: 20, name: t("productportfolio"), url: `${process.env.PUBLIC_URL}/productportfolio/ProductmrpList` },
        { id: 21, name: t("productmrplist"), url: `${process.env.PUBLIC_URL}/productportfolio/ProductmrpList`, },
        { id: 22, name: t("productviewlist"), url: `${process.env.PUBLIC_URL}/productportfolio/ProductviewList`, },
        { id: 23, name: t("Tenders"), url: ROUTES.TENDER, },
        { id: 24, name: t("TenderDetails"), url: ROUTES.TENDER, },
        { id: 25, name: t("DebarredList"), url: ROUTES.DEBBAREDLIST, },
        { id: 26, name: t("BlackList"), url: ROUTES.BLACKLIST, },
        { id: 27, name: t("AwardedTender"), url: ROUTES.AWARDEDLIST, },
        { id: 28, name: t("Media"), url: ROUTES.MEDIA, },
        { id: 29, name: t("EventCalendar"), url: ROUTES.MEDIA, },
        { id: 30, name: t("Support"), url: ROUTES.PACSTRAINING, },
        { id: 31, name: t("PACSTraining"), url: ROUTES.PACSTRAINING, },
        { id: 32, name: t("POSTraining"), url: ROUTES.POSTRAINING, },
        { id: 33, name: t("DownloadTrainingLink"), url: ROUTES.DOWNLOADLINK, },
        { id: 34, name: t("RetailSoftwareHelpline"), url: ROUTES.SOFTWAREHELPLINE, },
        { id: 35, name: t("SugamAppHelpline"), url: ROUTES.SUGAMHELPLINE, },
        { id: 36, name: t("KendraComplaints"), url: ROUTES.KENDRACOMPLAINTS, },
        { id: 37, name: t("VendorLabPortal"), url: ROUTES.VENDORPORTAL, },
        { id: 38, name: t("WebinarTutorials"), url: ROUTES.WEBINARTUTORIAL, },
        { id: 39, name: t("ContactUs"), url: ROUTES.CONTACTUS, },
        { id: 40, name: t("ARCHIVE"), url: ROUTES.ARCHIVE, },
        // { id: 42, name: "Debarred Vendor List", url: null, },
        // { id: 46, name: "Old Archives Data", url: null },
        { id: 47, name: "Varta Editions", url: null },
        { id: 48, name: t("RECRUITMENTS"), url: ROUTES.RECRUITMENT, },
        { id: 49, name: t("RTI"), url: ROUTES.RTIACT, },
        { id: 50, name: t("ApplyForKendra"), url: ROUTES.LOGINFORKENDRA, },
        { id: 51, name: t("RevocationOrder"), url: ROUTES.REVOCATIONORDER, },

    ];
}

export default SearchData
